<template>
  <vx-card no-shadow>

    <div class="flex items-center">
      <vs-input
        :type="showPassword ? 'text' : 'password'"
        class="w-full mb-base"
        label-placeholder="Nova Senha"
        v-model="new_password"
      />
      <span>
        <vs-icon
        :icon="showPassword ? 'visibility_off' : 'visibility'"
        class="absolute icon-grow"
        style="right:1.3em; top:2em; font-size:23px; cursor:pointer; user-select:none;"
        @click="showPassword = !showPassword"
        />
      </span>
    </div>

    <vs-input
      :type="showPassword ? 'text' : 'password'"
      class="w-full mb-base"
      label-placeholder="Confirmar Senha"
      v-model="confirm_new_password"
    />
    <password-strong :password="new_password"></password-strong>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button
        class="ml-auto mt-2"
        color="rgb(62, 201, 214)"
        type="filled"
        @click.prevent="updateUserPassword"
      >Salvar</vs-button>
    </div>
  </vx-card>
</template>

<script>
import moduleUser from "@/store/user/moduleUser"
import PasswordStrong from "@/components/password-strong/password-strong.vue"
import { filterPassword } from '@/utils'

export default {
  data() {
    return {
      new_password: "",
      confirm_new_password: "",
      showPassword: false,
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  components: {
    PasswordStrong
  },
  methods: {
    updateUserPassword() {
      if (this.new_password.length < 8 || this.confirm_new_password.length < 8) {
        return this.$vs.notify({
          color: 'danger',
          title: 'Ocorreu um ao atualizar a senha!',
          text: 'Os campos de senha devem conter, no mínimo, 8 caracteres!'
        })
      }

      if (this.new_password !== this.confirm_new_password) {
        return this.$vs.notify({
          color: 'danger',
          title: 'Ocorreu um ao atualizar a senha!',
          text: 'Sua confirmação está diferente da sua senha.'
        })
      }
      const passwordStrong = filterPassword(this.new_password)
      if (passwordStrong <= 75) {
            return this.$vs.notify({
              color: 'danger',
              title: 'Senha inválida!',
              text: 'A senha precisa ser forte para ser atualizada!'
            });
          }

      this.$store.dispatch('user/updatePassword', { password: this.new_password }).then(() => {
        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: 'Sua senha foi atualizada com sucesso!'
        })
      }).catch((error) => {
        console.log(error)
        this.$vs.notify({
          color: 'danger',
          title: 'Ocorreu um ao atualizar a senha!',
          text: 'Tivemos um erro inesperado, por favor entre em contato conosco.'
        })
      })
    }
  },
  created() {
    if (!moduleUser.isRegistered) {
      this.$store.registerModule('user', moduleUser)
      moduleUser.isRegistered = true
    }
  }
}
</script>

<style>
.icon-grow {
  transition: transform 0.3s ease;
}

.icon-grow:hover {
  transform: scale(1.2);
}
</style>
